import * as types from "./mutation_types";

const URL_BACKEND = process.env.VUE_APP_URL_BACKEND;
import axios from "@/lib/axioxAppli";

export const getItems = ({ commit }, rob) => {
  commit(types.tva_TOGGLE_LOADING);

  axios
    .get(URL_BACKEND + "api-tva/" + rob + "/")
    .then((response) => {
      commit(types.tva_TOGGLE_LOADING);
      commit(types.tva_SET_ITEMS, response.data);
    })
    .catch((e) => {
      commit(types.tva_TOGGLE_LOADING);
      commit(types.tva_SET_ERROR, e.message);
    });
};
